module.exports = __webpack_public_path__ + "img/0012.5089e2aa.jpg";